export const apiAxiosDefaults = {
    timeout: process.env.NODE_ENV === "production" ? 3005 : undefined,
    headers: {
        "Content-Type": "application/x-www-form-urlencoded",
    },
    // mock requests until server has stuff implemented
    // adapter: axiosTestAdapter({}),
};
//# sourceMappingURL=index.js.map